export default {
  title: 'Profil',
  fields: {
    name: {
      label: 'Nazwa',
      placeholder: 'Wprowadź nazwę restauracji',
    },
    short_name: {
      label: 'Krótka nazwa',
      placeholder: 'Wprowadź krótką nazwę restauracji',
      tooltip:
        'Domyślne nazwy restauracji bywają bardzo długie i mogą zawierać informacje dodatkowe, dlatego w niektórych przypadkach (np. dla krótkich powiadomień) wymagana jest krótsza wersja nazwy',
    },
    phone_number: {
      label: 'Numer telefonu',
      placeholder: 'Wpisz numer telefonu restauracji',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Wpisz adres e-mail restauracji',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug marki',
    },
    language: {
      label: 'Język',
      placeholder: 'Domyślne grupy',
      tooltip:
        'Język, który klienci widzą w witrynie tej restauracji, i domyślny dla jej personelu. Pozostaw puste, aby użyć języka marki. Personel może wybrać własny język dla swojego widoku.',
    },
    sms_name: {
      label: 'Nazwa SMS',
      placeholder: 'Nazwa wyświetlana SMS',
    },
    instagram_link: {
      label: 'Link do Instagrama',
      placeholder: 'Wpisz link do Instagrama restauracji',
    },
    website_link: {
      label: 'Link do strony',
      placeholder: 'Wpisz link do strony restauracji',
    },
    impressum_link: {
      label: 'Link do Impressum',
      placeholder: 'Wpisz link do Impressum restauracji',
    },
    timezone: {
      label: 'Strefa czasowa',
      placeholder: 'Wyszukaj miasto lub strefę czasową',
      tooltip:
        'Strefa czasowa, w której działa ta restauracja. Wpływa na znaczniki czasu zamówień, godziny otwarcia i harmonogram slotów. Została ustawiona na podstawie adresu restauracji podczas jej tworzenia — popraw ją tutaj, jeśli jest błędna.',
    },
    time_format: {
      label: 'Format czasu',
      placeholder: 'Użyj domyślnego dla kraju',
      tooltip:
        'Jak czasy są wyświetlane Twojemu zespołowi w panelu i portalu zamówień. Pozostaw puste, aby stosować konwencję regionu restauracji.',
      options: {
        '12h': '12-godzinny (5:30 pm)',
        '24h': '24-godzinny (17:30)',
      },
    },
    primary_color: {
      label: 'Kolor główny',
    },
    restaurant_type: {
      label: 'Typ restauracji i model obsługi',
    },
    cuisine_types: {
      label: 'Kategorie jedzenia i rodzaje kuchni',
    },
  },
  test_restaurant: {
    title: 'Restauracja testowa',
    description:
      'Ustaw tę restaurację jako testową, aby wypróbować drukowanie, e-maile, zamówienia i integracje w środowisku produkcyjnym. Nadal działa jak każda inna restauracja i nigdy nie jest rozliczana. Możesz mieć jedną restaurację testową.',
    description_test:
      'To jest Twoja restauracja testowa. Działa jak każda inna restauracja i nigdy nie jest rozliczana. E-maile i SMS-y do klientów o jej zamówieniach zaczynają się od [TEST].',
    mark: 'Oznacz jako restaurację testową',
    remove: 'Usuń oznaczenie Test',
    slot_taken: 'Masz już restaurację testową ({{name}}). Najpierw usuń oznaczenie Test z dotychczasowej.',
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    info_updated: 'Ustawienia zostały pomyślnie zaktualizowane',
  },
};
